// Tag normalisation + autocomplete history.
//
// `normalizeTagsClient` mirrors the server-side `normalizeTags` in routes.js
// so the chip-preview below the input matches what the API stores. Kept
// client-side so the user sees real-time feedback before submission.
export function normalizeTagsClient(raw) {
  const seen = new Set();
  const out = [];
  for (const part of String(raw).split(/[,\s]+/)) {
    const t = part.trim().toLowerCase();
    if (!t || seen.has(t)) continue;
    seen.add(t);
    out.push(t);
    if (out.length >= 20) break;
  }
  return out;
}

// Parses the current input and returns the trailing token being typed.
// "lunch, wo" → "wo". "lunch, work, " → "". Used to filter suggestions
// against what the user has already finished typing.
export function currentTagDraft(raw) {
  const parts = String(raw).split(/[,\s]+/);
  const last = parts[parts.length - 1] || '';
  return last.trim().toLowerCase();
}

// Removes the trailing draft token so suggestion-clicks can replace it.
export function replaceTrailingTag(raw, newTag) {
  const parts = String(raw).split(/[,\s]+/);
  parts.pop();
  parts.push(newTag);
  return parts.join(', ');
}

// Cap a tag-history list at the most-recent N unique tags. Used by
// AddTransactionModal's autocomplete to bound memory + DOM size for
// power users with hundreds of unique tags. Phase 95 fix: client-side
// history was unbounded (loaded all unique tags from the last 2000
// transactions) which ballooned DOM for the <datalist> + chip row.
// Pass the array in recency order (most-recent first); the function
// returns the first `limit` entries after dedup.
//
// Examples:
//   capHistoryAt(['lunch', 'work', 'lunch', 'taxi'], 3)
//     → ['lunch', 'work', 'taxi']
//   capHistoryAt(['a', 'b', 'a', 'c', 'd', 'e'], 3)
//     → ['a', 'b', 'c']
export function capHistoryAt(history, limit) {
  if (!Array.isArray(history)) return [];
  if (!Number.isFinite(limit) || limit <= 0) return [];
  const seen = new Set();
  const out = [];
  for (const t of history) {
    const key = String(t).trim().toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(key);
    if (out.length >= limit) break;
  }
  return out;
}